import React from "react";
import { hexToRgba } from "../core/color";

export default function GlassCard({
  style,
  children,
  accent,
  glow,
  glowAlpha = 0.85,
  hoverable = false,
  surface = "solid",
  className = "",
  ...rest
}) {
  const shadow = glow
    ? `0 0 30px ${hexToRgba(accent, glowAlpha * 0.45)}, 0 8px 32px rgba(0,0,0,0.5)`
    : "0 8px 32px rgba(0,0,0,0.4)";

  const hoverShadow = glow
    ? `0 0 50px ${hexToRgba(accent, glowAlpha * 0.75)}, 0 8px 40px rgba(0,0,0,0.6)`
    : "0 12px 40px rgba(0,0,0,0.5)";

  const classes = [
    "ecliptica-glass-card",
    surface === "glass" ? "ecliptica-glass-card--glass" : "ecliptica-glass-card--solid",
    hoverable ? "ecliptica-glass-card--hoverable" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      className={classes}
      {...rest}
      style={{
        "--glass-accent": accent,
        "--glass-shadow": shadow,
        "--glass-shadow-hover": hoverShadow,
        boxShadow: shadow,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
